import {AxiosResponse} from "axios";
import {IPageResponse} from "../common/interfaces/IPageResponse";

export function handleResponse(response: AxiosResponse<any>) {
    if (response.status === 200) {
        return response.data;
    } else if (response.status === 204) {
        return null;
    }
    return Promise.reject("Response returned error " + response.status + " >> "+ response.statusText);
}

export function handleApiException({ response }: any) {

    console.error("Response returned error " + response?.status, response?.statusText);
    return Promise.reject(response?.data || "Response returned error " + response?.status + " >> " + response?.statusText);
}


export function convertToPageable(response: any): IPageResponse<any> {
    if (response !== null)
        return response.data;
    else {
        console.error("Unable to convert response to page response");
        return response;
    }
}
export function extractData(response: any): any {
    if (response !== null)
        return response.data;
    else {
        console.error("Unable to extract data from response");
        return response;
    }
}

export function downloadFile(fileName: string, blob: Blob, url: string) {
    if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ fileUrl: url, fileName }));
    } else {
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(objectUrl);
    }
}

export function downloadFileWithPresignedUrl(fileUrl: string) {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.click();
}